<template>
  <section>
    <ul>
      <li>
        <vue-content-loading :width="290" :height="20">
          <rect x="0" y="0" rx="5" ry="5" width="290" height="20" />
        </vue-content-loading>
      </li>
      <li>
        <vue-content-loading :width="290" :height="20">
          <rect x="0" y="0" rx="5" ry="5" width="290" height="20" />
        </vue-content-loading>
      </li>
      <!-- <li>
        <vue-content-loading :width="290" :height="50">
          <rect x="0" y="0" rx="5" ry="5" width="290" height="50" />
        </vue-content-loading>
      </li>
      <li>
        <vue-content-loading :width="290" :height="50">
          <rect x="0" y="0" rx="5" ry="5" width="290" height="50" />
        </vue-content-loading>
      </li>
      <li>
        <vue-content-loading :width="290" :height="50">
          <rect x="0" y="0" rx="5" ry="5" width="290" height="50" />
        </vue-content-loading>
      </li>
      <li>
        <vue-content-loading :width="290" :height="50">
          <rect x="0" y="0" rx="5" ry="5" width="290" height="50" />
        </vue-content-loading>
      </li> -->
    </ul>
  </section>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'RecenteLoading',
  components: {
    VueContentLoading,
  },
};
</script>

<style lang="scss" scoped>
section {
  // background: #f7f6f8;

  & ul {
    padding: 0px;

    & li {
      padding: 12px 0px;
      border-bottom: 1px solid #ede;

      &:first-child {
        padding-top: 0px;
      }

      &:last-child {
        border-bottom: 0px;
        padding-bottom: 0px;
      }
    }
  }
}
</style>
